import Share from "./Share"
import { useConsole } from "contexts/Console"
import ModalContainer, { shareModal } from "components/modal/ModalContainer"

export default function ShareModal({ onClose, ...props }) {
  const console = useConsole()

  console.verbose("ShareModal(%o)", props)

  return (
    <ModalContainer onClose={onClose} className={`${shareModal} dark-theme`} modalHeading='modal-heading'>
      <Share {...props} inModal />
    </ModalContainer>
  )
}
